import React from 'react';
import ReactDOM from 'react-dom';

import { REPORT_BUTTON_PORTAL_ID, REPORT_INFO_PORTAL_ID } from '../report.types';

interface Props {
  buttonNode: React.ReactNode;
  children: React.ReactNode;
  infoNode: React.ReactNode;
  isPreviewMode?: boolean;
}
const ButtonPortalWrapper: React.FC<Props> = ({ buttonNode, infoNode, children, isPreviewMode = false }) => {
  const buttonPortalNode = document.getElementById(REPORT_BUTTON_PORTAL_ID);

  const infoPortalNode = document.getElementById(REPORT_INFO_PORTAL_ID);
  if (isPreviewMode) {
    return <>{children}</>;
  }
  return (
    <>
      {buttonPortalNode && ReactDOM.createPortal(buttonNode, buttonPortalNode)}
      {infoPortalNode && ReactDOM.createPortal(infoNode, infoPortalNode)}

      {children}
    </>
  );
};
export default ButtonPortalWrapper;
